import { Button } from "@/design-system/components/ui";
import { usePortalAuth } from "../PortalAuthContext";
import { PortalChangePasswordForm } from "./PortalChangePasswordForm";

/**
 * Admin/staff-initiated password reset — full-page gate rendered by
 * PortalChrome while `me.mustChangePassword` is set (a staff member assigned
 * this account a temporary password). The whole portal stays blocked until the
 * user picks their own password; the change-password endpoint clears the flag
 * and the follow-up `refresh()` lifts the gate. Mirrors the staff
 * ForcePasswordChangePage.
 */
export function PortalForcedPasswordChange() {
  const { me, refresh, logout } = usePortalAuth();

  return (
    <div className="min-h-screen bg-white-warm flex items-center justify-center p-space-5">
      <div className="w-[560px] max-w-full">
        <h1 className="font-display font-extrabold text-h2 uppercase tracking-wider text-onyx m-0">
          Set a new password
        </h1>
        <p className="text-body text-gray-mid mt-space-2 mb-space-4">
          {me?.fullName ? `Welcome, ${me.fullName}. ` : ""}
          Your current password was set by Phoenix Capital staff. Choose your own
          to continue — enter the temporary password you signed in with as the
          current password.
        </p>

        <div className="p-space-4 border border-border-light rounded-md bg-white-pure">
          <PortalChangePasswordForm
            submitLabel="Set my password"
            currentPasswordHelper="The temporary password Phoenix Capital gave you."
            onChanged={() => void refresh()}
          />
        </div>

        <div className="mt-space-4 text-center">
          <Button variant="text" size="sm" onClick={() => void logout()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
